var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBounce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7162 15.0546H12.4707C12.1054 15.0546 11.8011 15.3589 11.8011 15.7242C11.8011 16.0895 12.1054 16.3937 12.4707 16.3937H14.1338L10.4826 20.0038L2.55172 12.0729C2.28786 11.809 1.88217 11.809 1.61831 12.0729C1.35444 12.3368 1.35444 12.7425 1.61831 13.0063L10.0157 21.4037C10.1378 21.5258 10.32 21.6066 10.4824 21.6066C10.6449 21.6066 10.8271 21.5456 10.9492 21.4037L15.0464 17.3064V18.9696C15.0464 19.3349 15.3507 19.6392 15.716 19.6392C16.0813 19.6392 16.3856 19.3349 16.3856 18.9696V15.7241C16.365 15.3382 16.0815 15.0546 15.7162 15.0546Z",
    fill: "#DCDEE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5C20.24 5 18 7.24 18 10C18 12.76 20.24 15 23 15C25.76 15 28 12.76 28 10C28 7.24 25.76 5 23 5ZM23.5 12.5H22.5V11.5H23.5V12.5ZM23.5 10.5H22.5V7.5H23.5V10.5Z",
    fill: "#DCDEE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounce);
export default __webpack_public_path__ + "static/media/bounce.af7393aedbd2ba02e354507e47744266.svg";
export { ForwardRef as ReactComponent };